import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Link } from "react-router-dom";

import * as ActionTypes from '../actions';

import Heading from '../components/Heading';
import LoadingSpinner from '../components/LoadingSpinner';

const mapStateToProps = (state) => {
    return {
        processingSuccess: state.processingSuccess,
        processingError: state.processingError,
        isLoading: state.isLoading
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};

class Processing extends Component {

    render() {
        const {processingSuccess, processingError, isLoading} = this.props;

        return (
            <div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        {processingSuccess && (
                            <Heading>Vielen Dank für Ihre Anmeldung</Heading>
                        )}
                        {processingError && (
                            <Heading>Fehler bei der Anmeldung</Heading>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Processing);
